import { NgClass } from "@angular/common";
import { Component, ElementRef, Input, OnChanges, signal, SimpleChanges, ViewChild } from "@angular/core";
import { MatChipsModule } from "@angular/material/chips";

@Component({
  selector: 'status-badge',
  template: `
    <div [hidden]="!loading()" class="empty-badge"></div>
    <mat-chip [hidden]="loading()" #badge class="badge" [ngClass]="{
      'badge-green': isBadgeGreen,
      'badge-yellow': isBadgeYellow,
    }">
      {{text()}}
    </mat-chip>
  `,
  styleUrls: ['./status-badge.component.scss'],
  imports: [MatChipsModule, NgClass]
})
export class StatusBadgeComponent implements OnChanges {
  @Input() status: string;
  @Input() animate = false;

  protected text = signal('');

  @ViewChild('badge', { read: ElementRef }) badge!: ElementRef<HTMLElement>;
  loading = signal<boolean>(false);

  get isBadgeGreen() {
    return ['Published'].includes(this.status);
  }

  get isBadgeYellow() {
    return ['Pending Review'].includes(this.status);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['status']) {
      this.text.set(this.getStatusText(changes['status'].currentValue));
    }
    if (changes['status'] && !changes['status'].firstChange && this.animate) {
      // Wait for the view to update, then add the class
      this.loading.set(true);
      setTimeout(() => {
        this.loading.set(false);
        this.animateBadge();
      }, 1550);
    }
  }

  private animateBadge() {
    if (this.badge && this.badge.nativeElement) {
      const el = this.badge.nativeElement;
      el.classList.add('grow-from-50');
      setTimeout(() => {
        el.classList.remove('grow-from-50');
      }, 150);
    }
  }

  private getStatusText(status: string) {
    return status === 'Revised' ? 'Draft' : status;
  }
}